<ion-item id="present-alert" button lines="none" (click)="serveInfo()">
  <p>{{info}}</p>
</ion-item>
